const HomeIcon = () => {
      return (
        <svg
        width={16}
        height={17}
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_2619_1789"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={16}
          height={17}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 14V7.49999H3V14C3 14.2761 3.22386 14.5 3.5 14.5H12.5C12.7761 14.5 13 14.2761 13 14V7.49999H14V14C14 14.8284 13.3284 15.5 12.5 15.5H3.5C2.67157 15.5 2 14.8284 2 14Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 2.99999V6.49999L11 4.49999V2.99999C11 2.72384 11.2239 2.49999 11.5 2.49999H12.5C12.7761 2.49999 13 2.72384 13 2.99999Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.29289 1.99999C7.68342 1.60946 8.31658 1.60946 8.70711 1.99999L15.3536 8.64643C15.5488 8.84169 15.5488 9.15828 15.3536 9.35354C15.1583 9.5488 14.8417 9.5488 14.6464 9.35354L8 2.70709L1.35355 9.35354C1.15829 9.5488 0.841709 9.5488 0.646447 9.35354C0.451184 9.15828 0.451184 8.84169 0.646447 8.64643L7.29289 1.99999Z"
            fill="black"
          />
        </mask>
        <g mask="url(#mask0_2619_1789)">
          <rect y="0.5" width={16} height={16} fill="#A0AEC0" />
        </g>
      </svg>
      )
    }
    
    export default HomeIcon